/**
 * @generated SignedSource<<2efa5a6be0c4049cf39f4b28608a2563>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type IdentityProviderType = "AWS" | "Azure" | "GCP" | "SAML" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type SamlProviderCard_provider$data = {
  readonly displayName: string | null | undefined;
  readonly enableSignout: boolean;
  readonly idpNamespace: string;
  readonly idpType: IdentityProviderType;
  readonly name: string;
  readonly " $fragmentType": "SamlProviderCard_provider";
};
export type SamlProviderCard_provider$key = {
  readonly " $data"?: SamlProviderCard_provider$data;
  readonly " $fragmentSpreads": FragmentRefs<"SamlProviderCard_provider">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SamlProviderCard_provider",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableSignout",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "idpNamespace",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "idpType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "SAMLProvider",
  "abstractKey": null
};

(node as any).hash = "9dee883c129618e653b53fb59eca46cb";

export default node;
